/**
 * @deprecated Use ./contacts
 */
export * from './contacts';
